import config from '../config'
import APIService from '../APIService'

export default {
    fetchOfficeById: (id) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/officeadmin/${id}`,
            method: 'GET',
        })
    },
    getAll: (companyId) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/officeadmin/all/${companyId}`,
            method: 'GET',
        })
    },
    create: (data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/officeadmin`,
            method: 'POST',
            data,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    },
    update: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/officeadmin/${id}`,
            method: 'PATCH',
            data,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    },
    delete: (id, data) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/officeadmin/${id}`,
            method: 'DELETE',
            data
        })
    },
    getThemes: () => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/companyadmin/dynamicCombo/themes`,
            method: 'GET',
        })
    },
    getImage: (companyId, officeId, image) => {
        return APIService.fetch({
            url: `${config.api.url}/api/v1/files/GetOfficeImage/${companyId}/${officeId}/${image}`,
            method: 'GET',
            responseType: 'blob'
        })
    },
}